'use strict'

module.exports = del

var all = require('../all')

function del(h, node) {
  return h(node, 'delete', all(h, node))
}
